export default {
  Adjust: 'Adjust',
  Modify: 'ProvCalc',
  ChartEditor: 'ChartEditor',
  SubledgerAdd: 'BSMAdd',
  SubledgerBegBal: 'BSMTopside',
  SubledgerApprove: 'BSMApprove',
  UserAdmin: 'UserAdmin',
  RTPMenu: 'RTPMenu',
};
